import { motion } from "framer-motion";
import { LucideIcon } from "lucide-react";
import { Card } from "@/components/ui/card";

interface MetricCardProps {
  title: string;
  value: string | number;
  unit?: string;
  icon: LucideIcon;
  trend?: "up" | "down" | "neutral";
  delay?: number;
  highlight?: boolean;
}

export const MetricCard = ({
  title,
  value,
  unit,
  icon: Icon,
  delay = 0,
  highlight = false,
}: MetricCardProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.95 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ delay, duration: 0.3 }}
    >
      <Card className={`p-6 ${highlight ? "bg-primary/10 border-primary animate-glow-pulse" : "bg-card"}`}>
        <div className="flex items-start justify-between">
          <div className="flex-1">
            <p className="text-sm font-medium text-muted-foreground mb-2">
              {title}
            </p>
            <div className="flex items-baseline gap-2">
              <span className={`text-3xl font-bold ${highlight ? "text-primary" : "text-foreground"}`}>
                {value}
              </span>
              {unit && (
                <span className="text-lg text-muted-foreground">{unit}</span>
              )}
            </div>
          </div>
          <div className={`p-3 rounded-lg ${highlight ? "bg-primary/20" : "bg-secondary"}`}>
            <Icon className={`h-6 w-6 ${highlight ? "text-primary" : "text-muted-foreground"}`} />
          </div>
        </div>
      </Card>
    </motion.div>
  );
};
